module.exports = __webpack_public_path__ + "img/close.242e631c.svg";